import { MenuEntriesWithEnvironment } from "./menuElement";
import { MenuLeafNodeElement } from "./menuLeafNodeElement";
import template from "./menuParentNodeElement.hbs";
import Mousetrap from "mousetrap";
import { MenuEntry } from "./menuEntry";
import { MenuEntries } from "./sideMenu";
export class MenuParentNodeElement extends HTMLElement {

    private entries: MenuParentNodeModel;
    private _collapsed = true;
    constructor() {
        super();
        Mousetrap(this).bind(['right'], () => {
            this.collapsed = false;
            return false;
        });
        Mousetrap(this).bind(['left'], () => {
            this.collapsed = true;
            return false;
        });
    }

    public connectedCallback() {
        this.innerHTML = template(this.entries);
        for (const entry of this.entries.entries) {
            let element;
            if (entry.children == null) {
                element = document.createElement("s6-menu-node-leaf");
                (element as MenuLeafNodeElement).entry = {
                    ...entry,
                    environment: this.entries.environment,
                    level: this.entries.level + 1,
                    appPrefix: this.entries.appPrefix
                };
            } else {
                element = document.createElement("s6-menu-node-parent") as MenuParentNodeElement;
                (element as MenuParentNodeElement).model = {
                    entries: entry.children,
                    environment: this.entries.environment,
                    level: this.entries.level + 1,
                    appPrefix: this.entries.appPrefix,
                    key: entry.key
                };
            }
            this.querySelector(".c-menu-parent-node__children").append(element)
        }
        if (MenuParentNodeElement.findPageInChildren(this.entries)) {
            this.collapsed = false;
        }
        this.querySelector("a").addEventListener("click", () => {
            this.collapsed = !$(this.querySelector("a")).hasClass("c-menu-parent-node__a--hidden");
        })
    }

    public set model(children: MenuParentNodeModel) {
        this.entries = children;
        this.connectedCallback();
    }

    public set collapsed(collapsed) {
        this._collapsed = collapsed;
        this.querySelector("a").classList.toggle("c-menu-parent-node__a--hidden", collapsed);
        this.querySelector("div").classList.toggle("c-menu-parent-node__children--hidden", collapsed);
    }

    private static findPageInChildren(entries: MenuEntries) {
        let screenId;
        if (window.location.hash.startsWith("#!/l/")) {
            screenId = window.location.hash.split("/").slice(-1)[0].split(".").slice(-1)[0].split("?")[0];
        } else {
            screenId = window.location.hash.split("/").slice(-1)[0].split("?")[0];
            // For LDS that chan link to contents in page
            if (screenId.startsWith("#")) {
                screenId = window.location.hash.split("/").slice(-2)[0].split("?")[0];
            }
        }
        return MenuParentNodeElement.findPageInChildrenForId(screenId, entries.entries);
    }
    static findPageInChildrenForId(screenId: string, entries: MenuEntry[]) {
        for (const entry of entries) {
            if (entry.page == screenId || entry.legacyUrl?.includes(screenId) || entry.url?.includes(screenId)) {
                return true;
            }
            if (entry.children != null) {
                if (this.findPageInChildrenForId(screenId, entry.children)) {
                    return true;
                }
            }
        }
        return false;
    }
}

export function initMenuParentNodeWebComponent() {
    window.customElements.define("s6-menu-node-parent", MenuParentNodeElement);
}
export interface MenuParentNodeModel extends MenuEntriesWithEnvironment {
    key: string;
}
